import React from "react";
import { Outlet } from "react-router-dom";

const VesselCallPage: React.FC = () => {
  return (
    <div data-testid="vessel-call">
      <Outlet />
    </div>
  );
};

export default VesselCallPage;
